import { ActionTypes } from "../../constants/ActionTypes";
import { IEmployeePositionFolders } from "../../interfaces/EmployeePositionFolders";

// inboxEmployeePositionFolders
export const onClearInboxEmployeePositionFolders = () => {
    return {
        type: ActionTypes.CLEAR_INBOX_EMPLOYEE_POSITION_FOLDERS,
    };
};

export const onGetInboxEmployeePositionFolders = (parentId: number | null) => {
    return {
        type: ActionTypes.GET_INBOX_EMPLOYEE_POSITION_FOLDERS,
        payload: parentId,
    };
};

export const onGetDraftEmployeePositionFolders = (parentId: number | null) => {
    return {
        type: ActionTypes.GET_Draft_EMPLOYEE_POSITION_FOLDERS,
        payload: parentId,
    };
};

export const onGetTrashEmployeePositionFolders = (parentId: number | null) => {
    return {
        type: ActionTypes.GET_TRASH_EMPLOYEE_POSITION_FOLDERS,
        payload: parentId,
    };
};
export const onFetchInboxEmployeePositionfoldersSuccess = (
    employeePositionFolders: IEmployeePositionFolders[]
) => {
    return {
        type: ActionTypes.FETCH_INBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS,
        payload: employeePositionFolders,
    };
};

//SendBox
export const onClearSendBoxEmployeePositionFolders = () => {
    return {
        type: ActionTypes.CLEAR_SENDBOX_EMPLOYEE_POSITION_FOLDERS,
    };
};

export const onGetSendBoxEmployeePositionFolders = (
    parentId: number | null
) => {
    return {
        type: ActionTypes.GET_SENDBOX_EMPLOYEE_POSITION_FOLDERS,
        payload: parentId,
    };
};

export const onFetchSendBoxEmployeePositionFoldersSuccess = (
    employeePositionFolders: IEmployeePositionFolders[]
) => {
    return {
        type: ActionTypes.FETCH_SENDBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS,
        payload: employeePositionFolders,
    };
};

export const onFetchDraftEmployeePositionFoldersSuccess = (
    employeePositionFolders: IEmployeePositionFolders[]
) => {
    return {
        type: ActionTypes.FETCH_Draft_EMPLOYEE_POSITION_fOLDERS_SUCCESS,
        payload: employeePositionFolders,
    };
};

export const onFetchTrashEmployeePositionFoldersSuccess = (
    employeePositionFolders: IEmployeePositionFolders[]
) => {
    return {
        type: ActionTypes.FETCH_TRASH_EMPLOYEE_POSITION_FOLDERS_SUCCESS,
        payload: employeePositionFolders,
    };
};
